import { connectToStores } from 'fluxible-addons-react';
import { RouteStore } from 'fluxible-router';
import { QUANTUM_UI } from '../../../../flags';
import NavigationStore from '../../../stores/NavigationStore';
import SearchStore from '../../../stores/SearchStore';
import { SearchPage } from './SearchPage';
import { SearchPage as SearchPageOld } from './SearchPage.old';
var SearchPageComponent = QUANTUM_UI ? SearchPage : SearchPageOld;
export default connectToStores(SearchPageComponent, [SearchStore, RouteStore, NavigationStore], function (_a) {
    var getStore = _a.getStore;
    var _b = getStore(RouteStore).getCurrentRoute().query, query = _b.q, page = _b.page;
    return {
        query: query,
        page: +page,
        result: query ? getStore(SearchStore).getResult({ query: query, page: page }) : undefined,
        terms: getStore(NavigationStore).getGlossary().terms,
    };
});
